import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "input-error"
}
const _hoisted_7 = { class: "col-lg-4 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { class: "input-error" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-4 col-sm-6" }
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = { value: null }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "input-error" }
const _hoisted_16 = {
  key: 0,
  class: "col-lg-4 col-sm-6"
}
const _hoisted_17 = { class: "form-group mb-4" }
const _hoisted_18 = { class: "d-flex gap-3" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "input-error" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-lg-8 col-sm-6" }
const _hoisted_24 = { class: "form-group mb-4" }
const _hoisted_25 = { class: "input-error" }
const _hoisted_26 = { class: "col-lg-8 col-sm-6" }
const _hoisted_27 = { class: "form-group mb-4" }
const _hoisted_28 = { class: "input-error" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-4 col-sm-6" }
const _hoisted_31 = { class: "form-group mb-4" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "col-lg-4 col-sm-6" }
const _hoisted_34 = { class: "form-group mb-4" }
const _hoisted_35 = {
  key: 0,
  class: "dropdown-menu show w-100 mt-1"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "input-error" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-12" }
const _hoisted_40 = { class: "form-group mb-4" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "input-error" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-lg-12" }
const _hoisted_46 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_50 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_FilePond = _resolveComponent("FilePond")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label text-secondary" }, "Código", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el código",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notification.code) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('code'))),
                disabled: "true"
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.notification.code,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.ruc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errors.code), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label text-secondary" }, "Asunto", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el asunto",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.notification.subject) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('subject')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.notification.subject,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errors.subject), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.notification.type) = $event)),
                class: "form-select form-control h-55",
                "aria-label": "Default select example",
                disabled: "true"
              }, [
                _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsNotificationTypes, (notificationType, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: notificationType.id,
                    key: i
                  }, _toDisplayString(notificationType.name), 9 /* TEXT, PROPS */, _hoisted_14))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.notification.type]
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.errors.type), 1 /* TEXT */)
            ])
          ]),
          (_ctx.notification.type != _ctx.NOTIFICATION_TYPE_EMAIL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label text-secondary" }, "Icono", -1 /* HOISTED */)),
                  _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NOTIFICATION_ICONS, (icon) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: icon.key,
                        class: _normalizeClass(["icon-option", { selected: _ctx.notification.icon === icon.key }]),
                        onClick: ($event: any) => (_ctx.selectIcon(icon.key))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getIcon(icon.key),
                          class: "icon-img"
                        }, null, 8 /* PROPS */, _hoisted_20),
                        _createElementVNode("small", null, _toDisplayString(icon.label), 1 /* TEXT */)
                      ], 10 /* CLASS, PROPS */, _hoisted_19))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.errors.icon), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label text-secondary" }, "Contenido", -1 /* HOISTED */)),
              _createVNode(_component_TextEditor, {
                class: "text-editor",
                modelValue: _ctx.notification.htmlContent,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.notification.htmlContent) = $event)),
                placeholder: 'Ingrese el contenido',
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearError('htmlContent')))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.errors.htmlContent), 1 /* TEXT */)
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.notification.type == _ctx.NOTIFICATION_TYPE_EMAIL]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label text-secondary" }, "Contenido", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                style: {"resize":"none"},
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar el contenido",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.notification.txtContent) = $event)),
                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearError('txtContent')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vShow, _ctx.notification.type != _ctx.NOTIFICATION_TYPE_EMAIL],
                [
                  _vModelText,
                  _ctx.notification.txtContent,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errors.txtContent), 1 /* TEXT */)
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.notification.type != _ctx.NOTIFICATION_TYPE_EMAIL]
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label text-secondary" }, "Torneo", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-control h-45",
                "aria-label": "Default select example",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.notification.tournamentId) = $event)),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clearPlayer()))
              }, [
                _cache[23] || (_cache[23] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (tourney, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: tourney.id,
                    key: i
                  }, _toDisplayString(tourney.name), 9 /* TEXT, PROPS */, _hoisted_32))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.notification.tournamentId]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label text-secondary" }, "Jugador", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.notification.playerFullName) = $event)),
                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.fetchResults && _ctx.fetchResults(...args))),
                type: "text",
                class: "form-control",
                placeholder: "Escribe para buscar jugadores..."
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.notification.playerFullName]
              ]),
              (_ctx.showDropdown && _ctx.results.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.selectItem(item))
                      }, _toDisplayString(item.fullName), 9 /* TEXT, PROPS */, _hoisted_36))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.errors.matchId), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label text-secondary" }, "Multimedia", -1 /* HOISTED */)),
              (_ctx.notification.multimedia)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("img", {
                      src: _ctx.notification.multimedia,
                      alt: "Portada de Torneo",
                      class: "img-fluid mb-2 d-block"
                    }, null, 8 /* PROPS */, _hoisted_42),
                    _createElementVNode("button", {
                      onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeCoverFile && _ctx.removeCoverFile(...args)), ["prevent"])),
                      class: "btn btn-danger"
                    }, " Eliminar multimedia ")
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.notification.multimedia)
                ? (_openBlock(), _createBlock(_component_FilePond, {
                    key: 1,
                    name: "fileCover",
                    maxFileSize: '2MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(
                  ', '
                )}`,
                    credits: "",
                    onUpdatefiles: _ctx.handleUpdateFiles,
                    onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearError('fileCover')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.errors.fileCover), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_RouterLink, { to: "/notifications" }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.notification.id == 0 ? "Crear" : "Actualizar"), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_47)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}